import { sendToApi } from 'api/client'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { useMutation } from 'react-query'
import { Transcription } from 'types'

type TranscriptionAttributes = {
  media_object_id: number
  language: string
}

type Data = Transcription

type Variables = TranscriptionAttributes

const createTranscription = async (workspaceId: number, transcriptionAttributes: TranscriptionAttributes) => {
  const res = await sendToApi(`/w/${workspaceId}/transcriptions`, {
    method: 'POST',
    body: {
      transcription: transcriptionAttributes,
    },
  })

  if (res.type !== SUCCESS_RESPONSE_TYPE) {
    throw new Error(res.data)
  }
  return res.data.transcription
}

export const useCreateTranscription = () => {
  const workspaceId = useCurrentWorkspaceId()
  return useMutation<Data, Error, Variables>((vars) => createTranscription(workspaceId, vars))
}
